export default __webpack_public_path__ + "static/media/ow2.0ae4fab5.webp";